<div class="RateMovie" fxLayout="column" fxLayoutGap="20">
  <div fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayout="column" fxLayoutGap="50px">
      <div mat-dialog-title fxLayout="column">
        <h2 class="heading">My Ratings</h2>
        <span class="sub-title">(1 = poor; 10 = Great)</span>
      </div>
    </div>
<span class="material-icons close-icon mt-1" mat-dialog-close>cancel</span>

    <!-- <button mat-button mat-dialog-close class="btn-close">X</button> -->
  </div>

  <mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="center">
      <form *ngIf="NotRated" class="content" [formGroup]="rateForm" fxLayout="row"
        fxLayoutAlign="space-around">
        <div><input type="number" #box name="name" min="0" max="10" formControlName="rateValue"
            onKeyUp="if(this.value>10){this.value='10';}else if(this.value<0){this.value='0';}" />/10</div>
      </form>
      <div *ngIf="Rated" class="content">
        Thank You for Your Rating! You have rated {{ rateForm?.value?.rateValue }} for this movie
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="center" class="mt-4" fxLayoutGap="10px">
    <button class="btnclose" (click)="rateMovie()" *ngIf="NotRated">
      Rate
    </button>
    <button mat-button mat-dialog-close class="btnclose">Close</button>
  </mat-dialog-actions>
</div>